<template>
    <div>
        <hr/>
        <div class="form-group">
            <a
                :href="downloadUrl"
                class="btn btn-secondary pull-right"
            >
                Download .CSV
            </a>
            <label class="padding-bottom-10">Filter by Status</label>
            <div v-for="group in statusGroups" class="investment-status">
                <label class="investment-table-label">
                    {{ group.name }}:
                </label>
                <span
                    v-for="(label, status) in group.statuses"
                    @click="updateStatusFilter(status)"
                >
                    <a
                        class="btn btn-default investment-button"
                        :class="{active: statusFilter === status}"

                    >
                        {{ label }}
                    </a>
                     <span v-if="status === 'all' ">
                     <modal-help>
                       Cancelled trades are presented in the Cancelled filter only. If you are looking for a cancelled trade, please click on Cancelled below.
                     </modal-help>
                    </span>
                </span>
            </div>
        </div>
        <hr/>
      <div v-if="spinner" class="text-center">
        <img src="../../images/loader.gif" height="25px" width="25px"/>
        <p>Please wait ... </p>
      </div>
        <div class="form-group col-md-3 row">
            <label class="padding-bottom-10">Filter by User</label>
            <input type="text" v-model="search" class="form-control">
            <button type="button" class="btn btn-primary margin-top-10 margin-left-0 margin-bottom-20" @click="getSearchInvestments">Search</button>
        </div>
        <div class="form-group col-md-3 row">
            <label class="padding-bottom-10 ml-lg-3">Filter By Investment Id</label>
            <input type="text" v-model="searchID" class="form-control ml-lg-3">
            <button type="button" class="btn btn-primary margin-top-10 margin-bottom-20 ml-lg-3" @click="getSearchInvestments">Search</button>
        </div>
        <table class="table" v-if="dataReady">
            <thead>
                <tr>
                    <th
                        v-for="(column,label) in columns"
                        @click="updateSortFilter(column,label)"
                    >
                        {{ column.label }}
                      <span :class="arrowClass" v-if="column.active === true"></span>
                    </th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="investment in filteredInvestments" :key="investment.id">
                    <td>{{ investment.id }}</td>
                    <td><span class="label" :class="statusClass(investment.status)">{{ statusString(investment.status) }} </span></td>
                    <td class="text-right">{{ money(investment.amount) }}</td>
                    <td v-if="investment.offering.emd.is_non_brokered">
                        {{ date(investment.signed_on) }}
                    </td>
                    <td v-else="investment.offering.emd.is_community_coop">
                        {{ date(investment.client_application.signed_on) }}
                    </td>
                    <td>{{ investment.offering.name }}</td>
                    <td>{{ investment.investor.full_name }}</td>
                    <td>{{ investment.subscriber_name }}</td>
                    <td>
                        {{ 
                          investment.offering.bank_pad ?
                          ( investment.client_application &&
                            investment.client_application.data &&
                            investment.client_application.data.bank_pad_status === 'pad' ?
                            'Yes' : 'No'
                          ) :
                          'N/A'
                        }}
                    </td>
                    <td>
                        <a
                            :href="`/admin/${investment.offering.emd.slug}/subscriptions/${investment.id}`"
                            class="btn btn-default btn-xs"
                            @click="saveFilter(statusFilter)"
                        >
                            View
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
      <div>
        <pagination :data="investments" @pagination-change-page="getInvestments" :limit="10"></pagination>
      </div>
    </div>
</template>

<script>
  import accounting from "accounting"
  import moment from "moment"
  import axios from "axios";
  import pagination from "laravel-vue-pagination"
  import ModalHelp from "./ModalHelp";

  function by(getValue, dir) {
    return (a, b) => {
      let result = getValue(a) > getValue(b) ? 1 : -1
      return result * dir;
    }
  }

  export default {
    components: {
      pagination,
      ModalHelp,
    },
    computed: {
      filteredInvestments() {
        //const sort = this.columns[this.sortBy].sort
        //const sorted = this.investments.data.sort(by(sort, this.sortDir))

        return this.investments.data
      },
      downloadUrl() {
        const page = this.page;
        const statusFilter = this.statusFilter;
        const search = this.search;
        const searchID = this.searchID;
        const sortBy = this.sortBy;
        const sortDir = this.sortDir;

        return `/admin/${this.activeEmd.slug}/subscriptions.csv?page=${page}&filter=${statusFilter}&filterByName=${search}&filterByInvestmentId=${searchID}&orderBy=${sortBy}&order=${sortDir}`;
      }
    },
    methods: {
      getSearchInvestments() {
        if(this.search !== '' || this.searchID !== '') {
          this.getInvestments()
        }
      },
      getInvestments(page = 1) {
        this.spinner = true
        return axios.
          get('investments?page=' + page + '&filter=' + this.statusFilter + '&filterByName=' + this.search + '&filterByInvestmentId=' + this.searchID + '&orderBy=' + this.sortBy + '&order=' + this.sortDir).
          then(response => {
            this.investments = response.data
            this.totalPages = this.investments.last_page
            this.dataReady = true
            this.spinner = false
            this.page = page
          return Promise.resolve()
        })
      },
      updateStatusFilter(status) {
        this.statusFilter = status
        this.getInvestments()
      },
      columnArrow() {
          if (this.sortDir === 'asc')
            this.arrowClass = 'fa fa-angle-up'
          else
            this.arrowClass = 'fa fa-angle-down'
      },
      updateSortFilter(column,label) {
        let keyArray = Object.values(this.columns)
        keyArray.map( column => {
            column.active = false
        })
        if(!this.excludedColumns.includes(label)) {
          this.sortBy = label
          column.active = true
          column.direction === 'desc' ? column.direction = 'asc' : column.direction = 'desc'
          this.sortDir = column.direction
          this.getInvestments()
          this.columnArrow()
        }
      },
      money(amount) {
        return accounting.formatMoney(amount)
      },
      date(date) {
        if (!date) {
          return ''
        }
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
      },
      statusString(status) {
        let statusString = '';

        for (let group in this.statusGroups) {
          for (let match in this.statusGroups[group].statuses) {
            if (status === match) {
              statusString = this.statusGroups[group].statuses[match]
            }
          }
        }

        return statusString
      },
      statusClass(status) {
        let theClass = ''
        console.log('status', status)
        switch (status) {
          case 'pending signature':
          case 'in progress' :
          case 'incomplete' :
            theClass = 'label-default';
            break;
          case 'pending close' :
          case 'pending final approval':
          case 'pending dr approval':
          case 'pending cco approval':
          case 'pending delivery for approval':
          case 'pending approval':
          case 'pending id verification':
          case 'pending funding':
          case 'funded':
            theClass = 'label-warning';
            break;
          case 'counter signed':
          case 'complete':
          case 'approved':
            theClass = 'label-success';
            break;
          case 'rejected':
          case 'cancelled':
            theClass = 'label-danger';
            break;
          default:
            theClass = 'label-default';
        }
        return theClass
      },
      sort(column) {
        /*if (this.sortBy === column) {
          this.sortDir *= -1;
        }
        this.sortBy = column;*/
      },
      saveFilter(status) {
        let statusObj = {filter: status};
        window.history.pushState(
            statusObj,
            status,
            `/admin/${this.activeEmd.slug}/console?filter=${status}`
        )
      },
    },
    props: {
      'filter': '',
      'filterByName': '',
      'filterByInvestmentId': '',
      'orderBy': '',
      'order': '',
      'activeEmdProp' : Object,
    },
    data() {
      return {
        investments: {},
        activeEmd: this.activeEmdProp,
        dataReady: false,
        statusFilter: 'all',
        sortBy: this.orderBy ? this.orderBy : 'id',
        sortDir: this.order ? this.order : 'desc',
        search: this.filterByName ? this.filterByName : '',
        searchID: this.filterByInvestmentId ? this.filterByInvestmentId : '',
        spinner: false,
        page: 1,
        totalPages: 0,
        pageSize: 10,
        excludedColumns: ['status','account'],
        arrowClass: '',
        statusGroups: {
          All: {
            name: 'Unfiltered',
            statuses: {
              'all': 'All'
            }
          },
          Pre: {
            name: 'Pre-Sign',
            statuses: {
              'incomplete': 'Incomplete',
              'in progress': 'In Progress',
              'pending signature': 'Pending Signature'
            }
          },
          Post: {
            name: 'Post-Sign',
            statuses: {
              'pending approval': 'Pending Approval',
              'pending funding' : 'Pending Funding',
              'pending close': 'Pending Close',
            }
          },
          Marked: {
            name: 'Marked',
            statuses: {
              'complete': 'Complete',
              'cancelled': 'Cancelled',
              'rejected': 'Rejected',
              'counter signed': 'Counter Signed'
            }
          },
        },
        columns: {
          id: {
            label: 'Id',
            active: false,
            direction: 'desc',
            sort: i => i.id
          },
          status: {
            label: 'Status',
            active: false,
            direction: 'desc',
            sort: i => i.status
          },
          amount: {
            label: 'Amount',
            active: false,
            direction: 'desc',
            sort: i => i.amount
          },
          signed_on: {
            label: 'Date Signed',
            active: false,
            direction: 'desc',
            sort: i => i.signed_on
          },
          offering: {
            label: 'Offering',
            active: false,
            direction: 'desc',
            sort: i => i.offering.name
          },
          account: {
            label: 'Account',
            active: false,
            direction: 'desc',
            sort: i => i.investor.full_name
          },
          subscriber: {
            label: 'Subscriber',
            active: false,
            direction: 'desc',
            sort: i => i.subscriber_name
          },
          pad: {
            label: 'PAD',
            active: false,
            direction: 'desc',
            sort: i => i.clientApplication
          },
        }
      }
    },
    created() {
      this.getInvestments()
    }
  }
</script>
